import styled from 'styled-components';

import LinearProgress from '@mui/material/LinearProgress';

import ClearIcon from '@mui/icons-material/Clear';

export const FileUploadProgressContainer = styled.div<{
  invertColors: boolean;
}>`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${({ invertColors, theme }) => (invertColors ? 'inherit' : theme.palette.common.white)};
  padding: ${(props) => (props.invertColors ? '10px 10px 10px 0px' : '14px 10px 10px 16px')};
`;

export const StyledLinearProgress = styled(LinearProgress).attrs({
  variant: 'determinate',
})<{
  $success?: boolean;
}>`
  border-radius: 5px;

  .MuiLinearProgress-barColorPrimary {
    border-radius: 5px;
    background-color: ${(props) => (props.$success ? props.theme.palette.success.main : 'auto')};
  }
`;

export const FileDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilePropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin-left: 8px;
`;

export const FileControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledClearIcon = styled(ClearIcon)<{ invertColors: boolean }>`
  width: 18px;
  height: 18px;
  color: ${({ invertColors, theme }) => (invertColors ? 'rgba(255, 255, 255, 0.56)' : theme.palette.text.secondary)};
`;

export const FileNameText = styled.p<{ invertColors: boolean }>`
  font: normal normal normal 14px/16px Roboto;
  letter-spacing: 0px;
  color: ${({ invertColors, theme }) => (invertColors ? theme.palette.common.white : theme.palette.primary.dark)};
  margin: 0;
`;

export const FileSizeText = styled.p<{ invertColors: boolean }>`
  color: ${(props) => (props.invertColors ? props.theme.palette.common.white : 'rgba(0, 0, 0, 0.60)')};
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.17px;
  padding: 0px;
`;

export const FileProgressText = styled.p<{
  $success?: boolean;
}>`
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ $success, theme }) => ($success ? theme.palette.success.main : theme.palette.primary.main)};
`;

export const Thumbnail = styled.div<{
  thumbnail?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${(props) => (props.thumbnail ? `url(${props.thumbnail})` : 'none')};
  border-radius: 5px;
  width: 200px;
  height: 150px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
